import { useEffect, useContext } from 'react';
import { DataLayer } from '../../../libs/providers/datalayer/datalayer';
import { VIRTUAL_PAGES } from '../../../libs/providers/datalayer/constants/index';
import { WHATSAPP_LINK } from '../constants/whatsapp';
import { AppContext } from '../../commons/contexts/global/global-provider';
import {
  RESET_ACTION,
  AUTOEFECTIVO_PATH_ACTION,
} from 'domains/commons/contexts/global/staticData';
import { useLocation } from 'react-router-dom';
import MirrorPageEnums from '../enums/mirror-page';
import { getAutoefectivoName, getAutoefectivoPath } from '../utils/datalayer';
import {
  isLowerPricePage,
  isFromChannelPage,
  titleBannerPage,
} from '../utils/prices';

export const useNewPlan = () => {
  const { route, title } = VIRTUAL_PAGES.newPlan;
  const whatsappLink = WHATSAPP_LINK;
  const { actions } = useContext(AppContext);

  const location = useLocation();
  const { pathname } = location;

  const isFromCanal = isFromChannelPage(pathname);
  const titleBanner = titleBannerPage(pathname);

  const isLowerPrice = isLowerPricePage(pathname);
  const isTaxi = pathname === MirrorPageEnums.TAXI;

  const path = getAutoefectivoPath(pathname);
  const name = getAutoefectivoName(pathname);

  useEffect(() => {
    actions.dispatchNewPlan({ type: RESET_ACTION });
    actions.dispatchAutoefectivoPath({
      type: AUTOEFECTIVO_PATH_ACTION.set,
      payload: pathname,
    });

    DataLayer.setVirtualPage({
      pagePath: `auto-efectivo${path}-leads/${route}`,
      pageName: `Auto Efectivo${name} Leads - ${title}`,
      classPage: `Autos:PlanAutoEfectivo${name}Leads:${title}`,
      flujo: `General`,
    });
  }, []);

  return {
    whatsappLink,
    isLowerPrice,
    isFromCanal,
    isTaxi,
    titleBanner,
  };
};
